// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dN-z","twoColumnImage":"eN-z"};